<template>
    <div>
        <div class="row">
            <div class="col-12 col-sm-6">
                <card-title-component :title="$t('invitations.receivedInvitationsTitle')"></card-title-component>
                <div class="card-content">
                    <b-table hover
                             stacked="lg"
                             small
                             fixed
                             :items="localReceivedInvitations"
                             :total-rows="totalRows"
                             :fields="fieldsReceived">
                        <template slot="actions" slot-scope="row">
                            <a href="javascript:void(0)" v-if="!row.item.locked" @click.stop="acceptInvitation(row.item.id)">
                                {{$t('invitations.actions.accept')}}
                            </a>
                            <a href="javascript:void(0)" v-if="!row.item.locked" @click.stop="rejectInvitation(row.item.id)">
                                {{$t('invitations.actions.reject')}}
                            </a>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <card-title-component :title="$t('invitations.sentInvitationsTitle')"></card-title-component>
                <div class="card-content">
                    <b-table hover
                             stacked="lg"
                             small
                             fixed
                             :items="localSentInvitations"
                             :total-rows="totalRows"
                             :fields="fieldsSent">
                        <template slot="actions" slot-scope="row">
                            <a href="javascript:void(0)" v-if="!row.item.locked" @click.stop="cancelInvitation(row.item.id)">
                                {{$t('invitations.actions.cancel')}}
                            </a>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {
        INVITATIONS_NAMESPACE,
        INVITATIONS_GETTER,
        INVITATIONS_ACTION_GET_INVITATIONS,
        INVITATIONS_ACTION_INVITE,
        INVITATIONS_ACTION_ACCEPT,
        INVITATIONS_ACTION_REJECT,
        INVITATIONS_ACTION_CANCEL
    } from '../../store/modules/invitations-types'
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import i18n from '../../assets/i18n/lang'

    export default {
        name: 'Invitations',
        metaInfo () { return { title: i18n.t('invitations.meta') } },
        components: { 'card-title-component': CardTitleComponent },
        data () {
            return {
                currentPage: 1,
                perPage: 50,
                fieldsReceived: [
                    { key: 'inviterEmail', label: i18n.t('invitations.senderColumnHeading') },
                    { key: 'status', label: 'Status' },
                    { key: 'actions', label: '' }
                ],
                fieldsSent: [
                    { key: 'inviteeEmail', label: i18n.t('invitations.recipientColumnHeading') },
                    { key: 'status', label: 'Status' },
                    { key: 'actions', label: '' }
                ],
                totalRows: 0
            }
        },
        computed: {
            ...mapGetters(INVITATIONS_NAMESPACE, {
                invitations: INVITATIONS_GETTER
            }),
            localInvitations: {
                get () { return this.invitations },
                set (value) {}
            },
            localSentInvitations: {
                get () {
                    return this.invitations.filter(obj => {
                        return obj.direction === 'outgoing'
                    })
                }
            },
            localReceivedInvitations: {
                get () {
                    return this.invitations.filter(obj => {
                        return obj.direction === 'incoming'
                    })
                }
            }
        },
        methods: {
            ...mapActions(INVITATIONS_NAMESPACE, [
                INVITATIONS_ACTION_GET_INVITATIONS,
                INVITATIONS_ACTION_INVITE,
                INVITATIONS_ACTION_ACCEPT,
                INVITATIONS_ACTION_REJECT,
                INVITATIONS_ACTION_CANCEL
            ])
        },
        created () {
            this.fetchInvitations()
                .then(() => { this.totalRows = this.localInvitations.length })
                .catch((error) => { console.log(error) })
        }
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/guardian/InvitationsComponent.vue